export default __webpack_public_path__ + "static/media/Breeches of the Great Impi.afd74acf.jpg";